import { Injectable } from '@angular/core';
import { Preco } from '../models/preco';
import { StorageService } from '../alcance/services/storage.service';

@Injectable({
    providedIn: 'root'
})
export class AppdataService {

	public planos: Preco[] = [];
	public ordered!: Preco;
    public cart: Preco[] = [];
    public initStore = false;

    constructor(private storage: StorageService) {
        this.storage.get('cart').then((v) => {
            if(v)
                this.cart = v;
        })
    }

    addToCart(preco: Preco){
        this.cart.push(preco);
        this.storage.set('cart', this.cart);
    }


    remToCart(index: number){
        this.cart.splice(index, 1);
        this.storage.set('cart', this.cart);
    }

    clear(){
        this.cart = [];
        this.storage.set('cart', this.cart);
    }

    get total(): number{
        return this.cart.reduce((accumulator:any, currentPreco: any) => accumulator + currentPreco.valor, 0);
    }

}
